module.exports = __webpack_public_path__ + "img/popup-header-phone.4cdf20d7.png";